export default [
  { value: "none", label: "Selecionar" },
  { value: "3", label: "3 - Uso na agropecuária." },
  { value: "9", label: "9 - Outros." },
  {
    value: "12",
    label: "12 - Órgão de fomento e desenvolvimento agropecuário."
  }
];



// WEBPACK FOOTER //
// ./src/core/enum/motdesicms-values.enum.js